import React, {useContext, useEffect} from 'react';
import {
  closeWidget,
  confirmChecked,
  widget_Back,
} from '../../../assets/images/images';
import {useSelector} from 'react-redux';
import {EasyOnboardContext} from '../../../helpers/context';

export const Confirmation = () => {
  const {singleApp, singleWidget} = useSelector(state => state?.widgets);
  const {widgetData, setWidgetData} = useContext(EasyOnboardContext);

  useEffect(() => {
    setWidgetData(prev => ({
      ...prev,
      success_message:
        singleWidget?.widget?.success_message ||
        'Your verification has been successfully completed.',
      pending_message:
        singleWidget?.widget?.pending_message ||
        'Your verification is awaiting confirmation. Please wait.',
      error_message:
        singleWidget?.widget?.error_message ||
        'Your verification failed. Please try again.',
    }));
  }, [
    setWidgetData,
    singleWidget?.widget?.error_message,
    singleWidget?.widget?.pending_message,
    singleWidget?.widget?.success_message,
  ]);

  return (
    <>
      <header className="flex flex-col items-center mt-2 bg-white px-5 py-1 rounded-lg">
        <h4 className="font-medium text-[#1B2A4E]   text-sm">Confirmation</h4>
      </header>
      <div className="w-full max-w-sm px-2 py-6 bg-white mt-6">
        <div className="flex justify-between w-full px-3 py-6 items-center">
          <button
            disabled
            className="flex items-center w-16 !bg-white gap-2 h-fit"
          >
            <img src={widget_Back} alt="back" width={16} height={16} />
            <p className="text-[#84858D] text-[13px]  ">Back</p>
          </button>

          <header className="flex flex-col items-center">
            <img src={singleApp?.logo} alt="" className="max-h-10" />
          </header>

          <button disabled className="!bg-white w-16 flex justify-end">
            <img src={closeWidget} alt="" />
          </button>
        </div>

        <div className="flex flex-col items-center justify-center my-6 gap-5">
          <img src={confirmChecked} alt="icon" className="mb-6" />
          <div className=" w-full px-4 py-2 ">
            <div className="pb-4">
              <p className="text-sm text-body text-center">
                {widgetData?.success_message ||
                  'Your verification has been successfully completed.'}
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
